import type { Messages } from '@ah/i18n';

/** Greek — primary/default locale (ADR-015). Source of truth: a missing `en` key falls back here. */
export const el: Messages = {
  nav: {
    findTherapist: 'Εύρεση ψυχολόγου',
    checkIn: 'Check-in',
    settings: 'Ρυθμίσεις',
    signOut: 'Αποσύνδεση',
    signIn: 'Σύνδεση',
    back: '← Πίσω',
    backHome: 'Αρχική',
  },
  auth: {
    login: {
      title: 'Σύνδεση',
      email: 'Email',
      password: 'Κωδικός',
      submit: 'Σύνδεση',
      submitting: 'Σύνδεση…',
      missingFields: 'Παρακαλούμε συμπλήρωσε email και κωδικό.',
      twoFactorUnsupported: 'Η επιβεβαίωση δύο βημάτων δεν υποστηρίζεται για αυτόν τον τύπο λογαριασμού. Επικοινώνησε με την υποστήριξη.',
      failed: 'Η σύνδεση απέτυχε. Δοκίμασε ξανά.',
      noAccount: 'Δεν έχεις λογαριασμό;',
      registerLink: 'Εγγραφή ανώνυμα',
    },
    register: {
      title: 'Ξεκίνα ανώνυμα',
      intro: 'Διάλεξε ένα ψευδώνυμο — ο θεραπευτής σου δεν θα δει ποτέ το πραγματικό σου όνομα, εκτός αν επιλέξεις να το αποκαλύψεις.',
      email: 'Email',
      pseudonym: 'Ψευδώνυμο',
      pseudonymPlaceholder: 'π.χ. nyx_01',
      password: 'Κωδικός (min 10 χαρακτήρες, κεφαλαία/πεζά + αριθμός)',
      submit: 'Δημιουργία ανώνυμου λογαριασμού',
      submitting: 'Δημιουργία λογαριασμού…',
      failed: 'Η εγγραφή απέτυχε.',
      legalNoticePrefix: 'Με την εγγραφή σου αποδέχεσαι τους',
      legalNoticeJoiner: 'και την',
      termsLink: 'Όρους Χρήσης',
      privacyLink: 'Πολιτική Απορρήτου',
      alreadyRegistered: 'Έχεις ήδη λογαριασμό;',
      loginLink: 'Σύνδεση',
    },
  },
  home: {
    noTherapists: 'Δεν υπάρχουν ακόμα εγκεκριμένοι ψυχολόγοι σε αυτή την κατηγορία.',
    loading: 'Φόρτωση…',
    allCategories: 'Όλες οι κατηγορίες',
    defaultTherapistName: 'Ψυχολόγος',
    watchIntro: '▶ Δες το βίντεο παρουσίασης',
    fromPricePerSession: 'Από {{price}} / συνεδρία',
    bookSession: 'Κλείσε συνεδρία',
    startToBook: 'Ξεκίνα για να κλείσεις',
    translationMissing: '(δεν έχει μεταφραστεί ακόμα στα Αγγλικά)',
    speaks: 'Μιλά:',
  },
  matching: {
    title: 'Βρες θεραπευτή',
    specializationPlaceholder: 'Ειδίκευση (π.χ. άγχος) — προαιρετικό',
    languagePlaceholder: 'Γλώσσα συνεδρίας — προαιρετικό',
    anyLanguage: 'Οποιαδήποτε γλώσσα',
    search: 'Αναζήτηση',
    searching: 'Αναζήτηση…',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των θεραπευτών.',
    noResults: 'Κανένας θεραπευτής δεν ταιριάζει. Δοκίμασε διαφορετική ειδίκευση ή αναζήτησε χωρίς φίλτρο.',
    defaultTherapistName: 'Θεραπευτής',
    generalPractice: 'Γενική πρακτική',
    yearsExperience: '{{years}} έτη εμπειρίας',
    experienceNA: 'Εμπειρία μη διαθέσιμη',
    bookSession: 'Κλείσε συνεδρία',
    noBookableSessions: 'Δεν έχουν ρυθμιστεί ακόμα διαθέσιμες συνεδρίες.',
    translationMissing: '(προφίλ όχι ακόμα στα Αγγλικά — εμφανίζεται η ελληνική εκδοχή)',
    speaks: 'Μιλά:',
  },
  booking: {
    title: 'Κλείσε συνεδρία',
    titleWith: 'Κλείσε με {{name}}',
    defaultTherapistName: 'αυτόν τον θεραπευτή',
    needSignIn: 'Χρειάζεται να συνδεθείς για να κλείσεις συνεδρία.',
    signIn: 'Σύνδεση',
    noTherapistData: "Δεν έχουμε πια τη λίστα συνεδριών αυτού του θεραπευτή (η σελίδα λειτουργεί μόνο από αποτέλεσμα αναζήτησης).",
    findTherapist: 'Βρες θεραπευτή',
    sessionType: 'Τύπος συνεδρίας',
    dateTime: 'Ημερομηνία & ώρα',
    callMode: 'Τρόπος κλήσης',
    anonymousMode: 'Ανώνυμα — μόνο ήχος, αλλοιωμένη φωνή, χωρίς κάμερα',
    standardMode: 'Επώνυμα — η πραγματική σου φωνή και, αν το επιλέξεις, βίντεο',
    missingFields: 'Παρακαλούμε επίλεξε τύπο συνεδρίας και ημερομηνία/ώρα.',
    createError: 'Δεν ήταν δυνατή η δημιουργία της κράτησης. Δοκίμασε ξανά.',
    submit: 'Επιβεβαίωση κράτησης',
    submitting: 'Κράτηση…',
    almostThere: 'Σχεδόν έτοιμο',
    confirmedBody: "Η συνεδρία σου με {{name}} έχει προγραμματιστεί για {{when}}. Κρατάμε τη θέση σου μόλις εγκριθεί η πληρωμή — θα χρεωθείς μόνο όταν ο θεραπευτής αποδεχτεί. Αν ο θεραπευτής δεν απαντήσει εντός 72 ωρών, η κράτηση ακυρώνεται αυτόματα χωρίς χρέωση.",
    paymentError: 'Δεν ήταν δυνατή η έναρξη της πληρωμής. Δοκίμασε ξανά.',
    continueToPayment: 'Συνέχεια στην πληρωμή',
    redirectingToPayment: 'Μεταφορά στην πληρωμή…',
    backHome: 'Πίσω στην αρχική',
  },
  checkIn: {
    title: 'Check-in',
    intro: "Γράψε τι έχεις στο μυαλό σου. Δεν μοιράζεται με κανέναν εκτός αν το επιλέξεις — είναι ένας ιδιωτικός, γρήγορος έλεγχος πριν κλείσεις ραντεβού ή στείλεις μήνυμα σε θεραπευτή.",
    placeholder: 'Γράψε ελεύθερα — δεν υπάρχει λάθος τρόπος να το πεις.',
    ariaLabel: 'Τι έχεις στο μυαλό σου',
    submit: 'Check-in',
    submitting: 'Έλεγχος…',
    error: 'Δεν ήταν δυνατός ο έλεγχος αυτή τη στιγμή.',
    riskDetected: 'Αυτό που έγραψες ακούγεται πολύ δύσκολο αυτή τη στιγμή. Σκέψου να επικοινωνήσεις με μία από τις παρακάτω γραμμές, ή με κάποιον που εμπιστεύεσαι.',
    noRisk: 'Ευχαριστούμε που έκανες check-in. Μπορείς να συνεχίσεις σε κράτηση ή μήνυμα όποτε είσαι έτοιμος/η.',
    disclaimer: 'Αυτή η εφαρμογή δεν αντικαθιστά την επαγγελματική βοήθεια. Αν βρίσκεσαι σε κρίση, επικοινώνησε:',
    lineKlimaka: 'ΚΛΙΜΑΚΑ — Γραμμή πρόληψης αυτοκτονίας:',
    lineMinistry: 'Ψυχοκοινωνική στήριξη Υπουργείου Υγείας:',
    lineEmergency: 'Έκτακτη ανάγκη:',
    lineKlimakaSuffix: '(24/7, δωρεάν, ανώνυμα)',
    lineMinistrySuffix: '(24/7, δωρεάν)',
    back: 'Πίσω',
  },
  settings: {
    title: 'Ρυθμίσεις',
    appearance: 'Εμφάνιση',
    language: 'Γλώσσα',
    themeLight: 'Φωτεινό',
    themeDark: 'Σκοτεινό',
    themeSystem: 'Συστήματος',
    deleteAccount: 'Διαγραφή λογαριασμού',
    scheduledFor: 'Ο λογαριασμός σου έχει προγραμματιστεί για διαγραφή στις {{date}}. Μπορείς να το ακυρώσεις οποιαδήποτε στιγμή πριν από τότε.',
    cancelling: 'Ακύρωση…',
    cancelRequest: 'Ακύρωση αιτήματος διαγραφής',
    graceNotice: 'Αυτό ξεκινά μια περίοδο χάριτος {{days}} ημερών κατά την οποία μπορείς να ακυρώσεις. Μετά από αυτό, το προφίλ, τα μηνύματα και τα στοιχεία σύνδεσής σου ανωνυμοποιούνται μόνιμα. Οι κρατήσεις και τα τιμολόγια διατηρούνται μόνο όπως απαιτείται από τη φορολογική νομοθεσία, αποσυνδεδεμένα από την ταυτότητά σου. Εισήγαγε τον κωδικό σου για επιβεβαίωση.',
    password: 'Κωδικός',
    submitting: 'Υποβολή…',
    confirmDeletion: 'Επιβεβαίωση διαγραφής',
    cancel: 'Ακύρωση',
    deleteMyAccount: 'Διαγραφή λογαριασμού μου',
    deletionRequestError: 'Δεν ήταν δυνατή η υποβολή του αιτήματος διαγραφής.',
    deletionCancelError: 'Δεν ήταν δυνατή η ακύρωση του αιτήματος διαγραφής.',
    back: '← Πίσω',
  },
  call: {
    connecting: 'Σύνδεση…',
    waitingForOther: 'Αναμονή για τον άλλο συμμετέχοντα…',
    ending: 'Τερματισμός κλήσης…',
    ended: 'Η κλήση τερμάτισε — {{duration}}',
    anonymousNotice: 'Ανώνυμη κλήση — η φωνή σου είναι αλλοιωμένη, η κάμερα είναι απενεργοποιημένη.',
    mute: 'Σίγαση',
    unmute: 'Άρση σίγασης',
    endCall: 'Τερματισμός κλήσης',
    done: 'Τέλος',
    back: 'Πίσω',
    genericError: 'Κάτι πήγε στραβά.',
    needSignIn: 'Χρειάζεται να συνδεθείς για να μπεις σε αυτή την κλήση.',
    joinError: 'Δεν ήταν δυνατή η σύνδεση στην κλήση.',
  },
  legal: {
    backHome: '← Αρχική',
    termsLink: 'Όροι Χρήσης',
    privacyLink: 'Πολιτική Απορρήτου',
  },
  payments: {
    successTitle: 'Η πληρωμή εγκρίθηκε',
    successBodyPrefix: 'Ευχαριστούμε — η πληρωμή σου για αυτή τη συνεδρία',
    successBodyBooking: '(κράτηση {{id}})',
    successBodySuffix: "εγκρίθηκε και κρατείται. Δεν θα χρεωθείς εκτός αν ο θεραπευτής αποδεχτεί· αν δεν απαντήσει εντός 72 ωρών, η κράτηση ακυρώνεται αυτόματα χωρίς χρέωση.",
    backHome: 'Πίσω στην αρχική',
    cancelledTitle: 'Η πληρωμή δεν ολοκληρώθηκε',
    cancelledBody: 'Η κράτησή σου παραμένει δεσμευμένη, αλλά η πληρωμή δεν ολοκληρώθηκε. Μπορείς να δοκιμάσεις ξανά από τη λίστα κρατήσεών σου.',
  },
  common: {
    loading: 'Φόρτωση…',
  },
};
